import { ExtraOptions, RouterModule, Routes, CanActivate } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './helpers/auth.guard';
import { TableService } from './shared/services/table.service';
import { RedirectGuard } from './helpers/redirect.guard';
import { GetTablesForMenuAPIResolver } from './get-tables-for-menu.resolver';


export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard],
    resolve: { items:  GetTablesForMenuAPIResolver}
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
  },
  { path: '**', pathMatch:'full',children: [], canActivate:[RedirectGuard] },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {

  constructor(private tableService: TableService) {

  }

}
